const tools = [
  {
    technology: 'Git',
  },
  {
    technology: 'SVN',
  },
  {
    technology: 'Liferay',
  },
  {
    technology: 'Ansible',
  },
  {
    technology: 'Airflow',
  },
];

export default tools;
